export const gaEvent = (action, category, value=false) => {
  const label = `${category}-${action}${value ? ':' : ''} ${value? value : ''}`;
  const {ga} = window;
  if (ga) {
    ga('send', {
      hitType: 'event',
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
      eventValue: value
    });
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/ga.js
 **/